// Libs
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

// Config
import { PATHS } from '~fpu/config/constants';

// Types
import { Workshop } from '../types';

function fetchWorkshopDetails(workshopId: string) {
  return axios.get<Workshop>(PATHS.API.WORKSHOPS.DETAIL(workshopId));
}

function useWorkshopDetails(
  workshopId: string,
  { enabled }: { enabled?: boolean } = {}
) {
  return useQuery({
    queryKey: ['workshopDetails', workshopId],
    queryFn: () => fetchWorkshopDetails(workshopId),
    select: (data) => data.data,
    retry: false,
    enabled: enabled ?? Boolean(workshopId)
  });
}

export { useWorkshopDetails };
